import React from 'react';
import { ReactComponent as Coins } from '../../images/Icons/coins.svg';
import { navIconStyle } from "../../css/globalStyles";

export default function CoinsIcon(props) {

  return (
    <Coins style={{ ...props.medalStyle, ...navIconStyle.svgSizeList }} />
  );
}